import type { Config } from 'hb-react/frontoffice/apps/NewsIndex/types';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import type { User } from 'hb-react/types';

interface CreateNewsAppConfigParams {
  topicId: number;
  currentUser: User | null;
  topicContext: any;
}

export const createNewsAppConfig = ({
  topicId,
  currentUser,
  topicContext,
}: CreateNewsAppConfigParams): Config => {
  const newsUrl = currentUser
    ? Routes.topics_topic_news_index_path(topicId, {
        format: 'json',
      })
    : dynamicTopicResourcePath(
        Routes.topic_news_path(topicId, {
          format: 'json',
        }),
        topicContext,
      );

  const categoriesUrl = currentUser
    ? Routes.categories_topics_topic_news_index_path(topicId)
    : dynamicTopicResourcePath(
        Routes.categories_topic_news_index_path(topicId),
        topicContext,
      );

  const newsIndexUrl = dynamicTopicResourcePath(
    Routes.topic_news_path(topicId),
    topicContext,
  );

  return {
    custom: {
      page: {
        config: {
          blocks_renderer_template: twoColumnsTemplate.id,
        },
      },
    },
    routes: {
      categories_url: categoriesUrl,
      news_index_url: newsIndexUrl,
      news_url: newsUrl,
    },
  };
};
